import React from 'react';
import LinearProgress from '../../../../../components/LinearProgress';
import { categories } from '../../../../../utils';
import { useTranslation } from 'react-i18next';

const ProgressList = () => {
	const { t } = useTranslation();

	const getItems = categories.map((item, idx) => (
		<LinearProgress title={t(item.title)} limit={item.limit} key={idx} />
	));

	return <div>{getItems}</div>;
};

export default ProgressList;
